import { apiClient } from '@/lib/api'
import type { User } from '@/types/auth'

export interface UserWriteBody {
  username?: string
  display_name: string
  email?: string
  role_id: string
  active?: boolean
  // absent = unchanged; "" = clear (passkey-only); non-empty = set
  password?: string
}

export function fetchUsers() {
  return apiClient<User[]>('/users')
}

export function createUser(body: UserWriteBody & { username: string; password: string }) {
  return apiClient<User>('/users', { method: 'POST', body })
}

export function updateUser(id: string, body: UserWriteBody) {
  return apiClient<User>(`/users/${id}`, { method: 'PUT', body })
}

export function deleteUser(id: string) {
  return apiClient<void>(`/users/${id}`, { method: 'DELETE' })
}

// Admin quick-reset: the backend generates a one-time password returned in
// plaintext exactly once.
export function resetUserPassword(id: string) {
  return apiClient<{ password: string }>(`/users/${id}/reset-password`, { method: 'POST' })
}

// Create a login for a roster member (Employees tab action). An empty
// username means "derive from the employee name"; the password is generated
// server-side and returned exactly once.
export interface CreateUserFromEmployeeBody {
  employee_id: string
  role_id: string
  username?: string
  email?: string
}

export function createUserFromEmployee(body: CreateUserFromEmployeeBody) {
  return apiClient<{ user: User; password: string }>('/users/from-employee', {
    method: 'POST',
    body,
  })
}
